import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from '../reducers';
import thunkMiddleware from 'redux-thunk';

export default function configureStore(initialState) {
  return createStore(
      rootReducer,
      initialState,
      compose(
        applyMiddleware(
            thunkMiddleware     // lets us dispatch() functions
        )
      )
    );
}



/** WEBPACK FOOTER **
 ** ./src/app/store/configureStore.prod.js
 **/